import { getRequest, postRequest, patchRequest } from '@helpers/request'
import { logger } from '@helpers/logger'
import { convertToLocalTime } from '@helpers/convertToLocalTime'

export const getUserTournamentEntry = async (tournamentKey) => {
  const params = { tournamentKey }

  try {
    const { response, logComplete } = await getRequest('userTournamentEntry', params)

    if (!response.userTournamentEntry.userEntry) {
      response.userTournamentEntry.tournamentPoolEvents = Object.keys(response.userTournamentEntry.tournamentData.tournamentPoolEvents)
        .map((key) => {
          const event = response.userTournamentEntry.tournamentData.tournamentPoolEvents[key]
          const { eventDateLocal, eventTimeLocal } = convertToLocalTime(event.dateEvent, event.strTime)
          return { ...event, eventDateLocal, eventTimeLocal }
        })
        .sort((a, b) => new Date(b.dateEvent + 'T' + b.strTime) - new Date(a.dateEvent + 'T' + a.strTime))

      // Ensure banner data is included in tournamentData
      response.userTournamentEntry.tournamentData = {
        ...response.userTournamentEntry.tournamentData,
        tournamentBannerImage: response.userTournamentEntry.tournamentData.tournamentBannerImage || null,
        tournamentBannerBackgroundColor: response.userTournamentEntry.tournamentData.tournamentBannerBackgroundColor || null,
      }

      logComplete()
      return response.userTournamentEntry
    }

    response.userTournamentEntry.userEntry.userTournamentPoolEntryEvents = Object.keys(response.userTournamentEntry.userEntry.userTournamentPoolEntryEvents)
      .map((key) => {
        const event = response.userTournamentEntry.userEntry.userTournamentPoolEntryEvents[key]
        const { eventDateLocal, eventTimeLocal } = convertToLocalTime(event.dateEvent, event.strTime)
        return { ...event, eventDateLocal, eventTimeLocal }
      })
      .sort((a, b) => new Date(a.dateEvent + 'T' + a.strTime) - new Date(b.dateEvent + 'T' + b.strTime))

    // Ensure banner data is included in tournamentData
    response.userTournamentEntry.tournamentData = {
      ...response.userTournamentEntry.tournamentData,
      tournamentBannerImage: response.userTournamentEntry.tournamentData.tournamentBannerImage || null,
      tournamentBannerBackgroundColor: response.userTournamentEntry.tournamentData.tournamentBannerBackgroundColor || null,
    }

    logComplete()
    return response.userTournamentEntry
  } catch (error) {
    logger.error('getUserTournamentEntry', error)
  }
}

export const patchUserTournamentEntryEvent = async (tournamentKey, eventKey, predictionKey) => {
  const data = { tournamentKey, eventKey, predictionKey }

  try {
    const { response, logComplete } = await patchRequest('userTournamentEntryEvent', data)
    logComplete() // Call the completion logging function
    return response
  } catch (error) {
    logger.error('patchUserTournamentEntryEvent', error)
  }
}

export const postUserTournamentEntry = async (tournamentKey, inviteKey) => {
  const data = { tournamentKey, inviteKey }
  try {
    const { response, logComplete } = await postRequest('userTournamentEntry', data)

    response.userTournamentEntry.userEntry.userTournamentPoolEntryEvents = Object.keys(response.userTournamentEntry.userEntry.userTournamentPoolEntryEvents)
      .map((key) => {
        const event = response.userTournamentEntry.userEntry.userTournamentPoolEntryEvents[key] // Access the event using the key
        const { eventDateLocal, eventTimeLocal } = convertToLocalTime(event.dateEvent, event.strTime)
        return { ...event, eventDateLocal, eventTimeLocal }
      })
      .sort((a, b) => new Date(a.dateEvent + 'T' + a.strTime) - new Date(b.dateEvent + 'T' + b.strTime))

    logComplete() // Call the completion logging function
    return response.userTournamentEntry
  } catch (error) {
    logger.error('postUserTournamentEntry', error)
  }
}

export const getTournamentKey = async (entryKey) => {
  const params = { entryKey }

  try {
    const { response, logComplete } = await getRequest('tournamentKey', params)
    logComplete()
    return response
  } catch (error) {
    logger.error('getTournamentKey', error)
  }
}
